import React from 'react';
import './Projects.css';

const solutions = [
  {
    id: '01',
    name: 'aXtion Telemed',
    category: 'Telehealth Platform',
    description: 'Connecting patients to licensed providers through secure video consultations, real-time messaging, and remote monitoring — delivering quality care from anywhere.',
    featured: false,
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="10" width="40" height="28" rx="4" stroke="currentColor" strokeWidth="2"/>
        <circle cx="24" cy="24" r="7" stroke="currentColor" strokeWidth="2"/>
        <path d="M24 17v-4M24 31v4M17 24h-4M31 24h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="24" cy="24" r="2.5" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: '02',
    name: 'aXtion EHR Systems',
    category: 'Electronic Health Records',
    description: 'Fully integrated EHR system for clinics and hospitals of all sizes — streamlining patient records, clinical workflows, billing, and compliance in one secure platform.',
    featured: true,
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10" y="4" width="28" height="40" rx="3" stroke="currentColor" strokeWidth="2"/>
        <path d="M18 16h12M18 22h12M18 28h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M22 34h4v6l-2-2-2 2v-6z" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: '03',
    name: 'aXtion Students Portal',
    category: 'Academic Management',
    description: 'All-in-one academic management platform for schools and universities — enrollment, course scheduling, grades, attendance, and student communication in a unified digital campus.',
    featured: false,
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 8L44 18l-20 10L4 18l20-10z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
        <path d="M12 23v10c0 4 5.4 7 12 7s12-3 12-7V23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M44 18v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="44" cy="30" r="2" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: '04',
    name: 'Fintech Integration',
    category: 'Financial Technology',
    description: 'Seamless financial technology integration for businesses — payment processing, banking APIs, digital wallets, and compliance-ready fintech infrastructure built for speed and security.',
    featured: false,
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="12" width="40" height="28" rx="4" stroke="currentColor" strokeWidth="2"/>
        <path d="M4 20h40" stroke="currentColor" strokeWidth="2"/>
        <circle cx="12" cy="30" r="3" stroke="currentColor" strokeWidth="2"/>
        <path d="M22 28h12M22 32h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M28 8l-4 4 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M36 8l-4 4 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    id: '05',
    name: 'Enterprise Software Solutions',
    category: 'Custom Enterprise Software',
    description: 'Custom enterprise-grade software tailored to your operational needs — ERP systems, workflow automation, business intelligence dashboards, and scalable cloud deployments.',
    featured: false,
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="6" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
        <rect x="26" y="6" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
        <rect x="6" y="26" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
        <rect x="26" y="26" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
  },
];

const Projects = () => {
  return (
    <section id="projects" className="projects">
      <div className="projects-inner">
        <div className="projects-header fade-up">
          <span className="projects-label">OUR SOLUTIONS</span>
          <div className="projects-wave">〰〰</div>
          <h2 className="projects-title">
            Latest showcase and solutions<br />to our customers!
          </h2>
        </div>

        <div className="solutions-grid">
          {solutions.map((sol) => (
            <div
              key={sol.id}
              className={`solution-card fade-up${sol.featured ? ' featured' : ''}`}
            >
              <div className="solution-icon">{sol.icon}</div>
              <p className="solution-desc">{sol.description}</p>
              <div className="solution-footer">
                <h3 className="solution-name">{sol.name}</h3>
                <a href="#contact" className="solution-link">
                  Know More {sol.featured ? '→' : ''}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
